<template>
  <div class="section--column--center">
    <div class="TwoFactorWizardstep-size-security data--center">
      <span>{{ $t('TwoFactorAuth.SetupScan') }}</span>
      <QRCodeVue3 :value="qrdata" :key="qrdata" :height="qrsize" :width="qrsize"></QRCodeVue3>
      <p>{{ $t('TwoFactorAuth.SetupManual') }}</p>
      <div class="data--aligncenter aligndata--separate5">
        <p><strong>{{ $t('TwoFactorAuth.SetupManualQuestion') }}</strong></p>
        <button class="pi pi-question-circle" style="color: var(--ingeteam-color)" @click="openHelp"></button>
      </div>
      <div class="flex__separate05">
        <span class="code--field">{{ secretKey }}</span>
        <!--    <button (click)="copyToClipboard()" class="btn&#45;&#45;copycode">-->
        <!--      <i class="pi pi-copy" style="font-size: 1.5rem; cursor: pointer"></i>-->
        <!--    </button>-->
      </div>
    </div>
    <div class="flex__separate05">
      <button @click="toBack"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.previous') }}
      </button>
      <button @click="toContinue"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.next') }}
      </button>
    </div>
  </div>


</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref} from "vue";
import {AuthenticatorSetupResponse, AuthenticatorValidationStatus} from "@/types/autenticationresult";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import {useStore} from "vuex";
import ResponseData from "@/types/ResponseData";
import QRCodeVue3 from "qrcode-vue3/src/QRCodeVue3.vue";
import APIDataServices from "@/services/APIDataServices";

export default defineComponent({
  name: 'setup2fa',
  components: {
    QRCodeVue3
  },
  setup() {

    const secretKey = ref();
    const qrdata = ref();
    const qrsize = ref(150);

    const store = useStore();

    const TwoFactorAuthSetup = () => {
      const qrdataStore = store.getters.getTwoFactorQRCode;
      const secretKeyStore = store.getters.getTwoFactorSecretKey;
      if (!qrdataStore) {
        APIDataServices.setAuthenticatorSetup(store.getters.getTwoFactorAuthToken)
            .then((response: ResponseData) => {
              // console.log('setAuthenticatorSetup. response: ' + JSON.stringify(response));
              const setupResponse = response.data as AuthenticatorSetupResponse;
              // console.log('setAuthenticatorSetup. setupResponse: ' + JSON.stringify(setupResponse));
              secretKey.value = setupResponse.secretKey;
              qrdata.value = setupResponse.qrCode;
              store.commit("setTwoFactorQRCode", qrdata.value);
              store.commit("setTwoFactorSecretKey", secretKey.value);
            })
            .catch((e: Error) => {
              console.log(e);
              // isLoading.value = false;
            });
      } else {
        qrdata.value = qrdataStore;
        secretKey.value = secretKeyStore;
      }
    };

    const openHelp = () => {
      store.commit("setTwoFactorHelp", true);
    }
    const toContinue = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(true, store);
    }

    const toBack = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(false, store);
    }

    onMounted(() => {
      TwoFactorAuthSetup();
    });

    //
    return {
      toContinue,
      toBack,
      openHelp,
      secretKey,
      qrdata,
      qrsize
    }
  }
});

</script>


<style scoped>
.code--field {
  background-color: lightgrey;
  border: 2px solid #000;
  border-radius: 15px;
  padding: 5px;
  display: inline-block;
}
</style>
